import Main from './Main.svelte';
import { requireAuth } from './utility/AccountUtility';
import { mount } from "svelte";
let target = document.body.querySelector('mainContent');
let mainView = null;
requireAuth(() => {
    mainView = mount(Main, {
        target: target.parentElement,
        anchor: target,
        props: {}
    });
});
export default mainView;
